import { ListItemButton, styled } from '@mui/material';
import type { Theme } from '@mui/material/styles';

function activeItemStyle(theme: Theme, rootItem: boolean) {
  return {
    color: rootItem ? theme.palette.text.primary : '#1C242E',
    backgroundColor: rootItem ? '#F1F5FF' : '#F6F7F8',
    fontWeight: 'bold',
  };
}

const StyledNavItem = styled(ListItemButton, {
  shouldForwardProp: (prop) =>
    prop !== 'active' &&
    prop !== 'depth' &&
    prop !== 'collapsed' &&
    prop !== 'hasActiveDescendant' &&
    prop !== 'isLastChild',
})<{
  active?: boolean;
  depth?: number;
  collapsed?: boolean;
  hasActiveDescendant?: boolean;
  isLastChild?: boolean;
}>(({ theme, active, depth = 0, collapsed, hasActiveDescendant }) => ({
  minHeight: 44,
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingRight: theme.spacing(1),
  paddingLeft: collapsed
    ? theme.spacing(1)
    : depth > 0
    ? theme.spacing(0.5 + depth * 1)
    : theme.spacing(1.5),
  margin: theme.spacing(0.25, 1),
  borderRadius: theme.shape.borderRadius,
  position: 'relative',
  transition: theme.transitions.create(['background-color', 'color'], {
    duration: theme.transitions.duration.shorter,
  }),

  ...(active || hasActiveDescendant
    ? {
        ...activeItemStyle(theme, depth === 0),
        '&:hover': {
          backgroundColor: depth === 0 ? '#e3edff' : '#ececec',
          color: depth === 0 ? '#4F88FC' : '#1C242E',
        },
      }
    : {
        color: theme.palette.text.secondary,
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
          color: theme.palette.text.primary,
        },
      }),

  ...(collapsed && {
    justifyContent: 'center',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  }),

  '&.Mui-disabled': {
    opacity: 0.48,
    pointerEvents: 'none',
  },
  ...(depth > 0 && !collapsed
    ? {
        '&::after': {
          content: '""',
          position: 'absolute',
          width: '10px',
          height: '16px',
          left: 0,
          top: '50%',
          transform: 'translateY(-50%) translate(-8px, -6px)',
          backgroundColor: '#e0e0e0',
          mask: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'%3E%3Cpath d='M1 1v4a8 8 0 0 0 8 8h4' stroke='%23efefef' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat 50% 50%/100% auto`,
          WebkitMask: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'%3E%3Cpath d='M1 1v4a8 8 0 0 0 8 8h4' stroke='%23efefef' stroke-width='3' stroke-linecap='round'/%3E%3C/svg%3E") no-repeat 50% 50%/100% auto`,
          zIndex: 1,
        },
      }
    : {}),
}));

export default StyledNavItem;
